module.exports = __webpack_public_path__ + "static/img/adjust.c930675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adjust.png
// module id = xVpr
// module chunks = 7